import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

export default function LoadingState({ label = 'Carregando...' }) {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" p={4} gap={2}>
      <CircularProgress size={20} />
      <Typography variant="body2" color="text.secondary">{label}</Typography>
    </Box>
  );
}

